import { IShadowGenericContractCreate } from '../interfaces/shadowGenericContractCreate';
import { PhaseContract } from '../enums/phaseContract.enum';
import { TypeContract } from '../enums/typeContract.enum';
import { AttachType } from '../enums/attachType';
import { TypeRequest } from '../enums/typeRequest.enum';
import { BrandType } from '../enums/brandType';
import { OnCallPeriod } from '../enums/onCallPeriod';
import { ClientTitle } from '../enums/clientTitle';

export class ShadowGenericContractCreate implements IShadowGenericContractCreate {
    address: string;
    atPlace: string;
    city: string;
    createdDateTime: Date;
    documentExpirationDate: Date;
    documentGrantedBy: string;
    documentNumber: string;
    iban: string;
    id: number;
    idAgent: number;
    idLegalRepresentative: number;
    invoicingMode: string;
    istatCodeCity: string;
    lastModifiedDateTime: Date;
    modeSendInvoice: string;
    note: string;
    numberAddress: string;
    paymentMode: string;
    sepaChoice: boolean;
    phase: PhaseContract;
    postalCode: string;
    province: string;
    shortProvince: string;
    signatureDate: Date;
    signaturePlace: string;
    typeContract: TypeContract;
    typeDocument: AttachType;
    typeRequestSupply: TypeRequest;
    debtorClientName: string;
    debtorFiscalCode: string;
    brand: BrandType;
    onCallPeriod: OnCallPeriod;
    clientTitle: ClientTitle;
    merchandisingDataTreatment: boolean;
    profilingDataTreatment: boolean;
    communicationDataTreatment: boolean;
    generalDataTreatment: boolean;
    verificationCallPreferredTimeFrom: Date;
    verificationCallPreferredTimeTo: Date;
    verificationCallPreferredDate: Date;
    renounceOfChangeOfMindPeriod: boolean;
    adesioneADistanza: boolean;
    delegaCf: string;
    delegaLastname: string;
    delegaName: string;
    chiamataBenvenutoPreferredTimeFrom: Date;
    chiamataBenvenutoPreferredTimeTo: Date;
    chiamataBenvenutoPreferredDate: Date;
    isVocalOrderListened: boolean;
    isPreScreeningOk: boolean;
    isPreScreeningError: boolean;


    constructor(sc?: IShadowGenericContractCreate) {
        if (sc) {
            this.address = sc.address;
            this.atPlace = sc.atPlace;
            this.city = sc.city;
            this.createdDateTime = sc.createdDateTime;
            this.documentExpirationDate = sc.documentExpirationDate;
            this.documentGrantedBy = sc.documentGrantedBy;
            this.documentNumber = sc.documentNumber;
            this.iban = sc.iban;
            this.id = sc.id;
            this.idAgent = sc.idAgent;
            this.idLegalRepresentative = sc.idLegalRepresentative;
            this.invoicingMode = sc.invoicingMode;
            this.istatCodeCity = sc.istatCodeCity;
            this.lastModifiedDateTime = sc.lastModifiedDateTime;
            this.modeSendInvoice = sc.modeSendInvoice;
            this.note = sc.note;
            this.numberAddress = sc.numberAddress;
            this.paymentMode = sc.paymentMode;
            this.sepaChoice = sc.sepaChoice;
            this.phase = sc.phase;
            this.postalCode = sc.postalCode;
            this.province = sc.province;
            this.shortProvince = sc.shortProvince;
            this.signatureDate = sc.signatureDate != null ? new Date(sc.signatureDate) : null;
            this.signaturePlace = sc.signaturePlace;
            this.typeContract = sc.typeContract;
            this.typeDocument = sc.typeDocument;
            this.typeRequestSupply = sc.typeRequestSupply;
            this.debtorClientName = sc.debtorClientName;
            this.debtorFiscalCode = sc.debtorFiscalCode;
            this.brand = sc.brand;
            this.onCallPeriod = sc.onCallPeriod;
            this.clientTitle = sc.clientTitle;
            this.merchandisingDataTreatment = sc.merchandisingDataTreatment;
            this.profilingDataTreatment = sc.profilingDataTreatment;
            this.communicationDataTreatment = sc.communicationDataTreatment;
            this.generalDataTreatment = sc.generalDataTreatment;
            this.verificationCallPreferredTimeFrom = sc.verificationCallPreferredTimeFrom != null ? new Date(sc.verificationCallPreferredTimeFrom) : null;
            this.verificationCallPreferredTimeTo = sc.verificationCallPreferredTimeTo != null ? new Date(sc.verificationCallPreferredTimeTo) : null;
            this.verificationCallPreferredDate = sc.verificationCallPreferredDate != null ? new Date(sc.verificationCallPreferredDate) : null;
            this.renounceOfChangeOfMindPeriod = sc.renounceOfChangeOfMindPeriod;
            this.adesioneADistanza = sc.adesioneADistanza;
            this.delegaCf = sc.delegaCf;
            this.delegaLastname = sc.delegaLastname;
            this.delegaName = sc.delegaName;
            this.chiamataBenvenutoPreferredTimeFrom = sc.chiamataBenvenutoPreferredTimeFrom;
            this.chiamataBenvenutoPreferredTimeTo = sc.chiamataBenvenutoPreferredTimeTo;
            this.chiamataBenvenutoPreferredDate = sc.chiamataBenvenutoPreferredDate;
            this.isVocalOrderListened = sc.isVocalOrderListened;
            this.isPreScreeningOk = sc.isPreScreeningOk;
            this.isPreScreeningError = sc.isPreScreeningError;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/shadowGenericContractCreate.ts